"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = download;

var _fileSaver = require("file-saver");

var _fileSaver2 = _interopRequireDefault(_fileSaver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function download(data, strFileName, strMimeType) {
	var self = window,
	    // this script is only for browsers anyway...
	defaultMime = "application/octet-stream",
	    // this default mime also triggers iframe downloads
	mimeType = strMimeType || defaultMime,
	    payload = data,
	    anchor = document.createElement("a"),
	    toString = function toString(a) {
		return String(a);
	},
	    myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
	    fileName = strFileName || "download",
	    blob,
	    url,
	    reader;
	if (typeof data == "string") {
		anchor.href = data; // assign href prop to temp anchor
		if (anchor.href.indexOf(data) !== -1) {
			url = anchor.href; // assign href prop to temp anchor
		}
	}
	myBlob = myBlob.call ? myBlob.bind(self) : Blob;

	if (String(this) === "true") {
		//reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
		payload = [payload, mimeType];
		mimeType = payload[0];
		payload = payload[1];
	}

	if (url && url.length < 2048) {
		if (!("download" in anchor)) {
			return new Promise(function (resolve, reject) {
				var f = document.createElement("iframe");
				document.body.appendChild(f);

				f.src = url;
				setTimeout(function () {
					document.body.removeChild(f);
					resolve();
				}, 3000);
			});
		}

		fileName = strFileName || url.split("/").pop().split("?")[0];

		// if the browser determines that it's a potentially valid url path:
		var ajax = new XMLHttpRequest();
		ajax.open("GET", url, true);
		if (process.env.NODE_ENV == "test") {
			// Sinon FakeServer doesn't like blob
			ajax.responseType = "arraybuffer";
		} else {
			ajax.responseType = "blob";
		}
		return new Promise(function (resolve, reject) {
			ajax.onload = function (e) {
				if (ajax.status >= 400) {
					return reject(ajax);
				}
				var downloaded = download(e.target.response, fileName, defaultMime);
				if (downloaded.then) {
					return downloaded.then(resolve).catch(reject);
				} else {
					resolve();
				}
			};
			ajax.onerror = reject;
			setTimeout(function () {
				ajax.send();
			}, 0); // allows setting custom ajax headers using the return:
			return ajax;
		});
	} // end if url?

	if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
		payload = dataUrlToBlob(payload);
	} else {
		//not data url, is it a string with special needs?
		if (/([\x80-\xff])/.test(payload)) {
			var i = 0,
			    tempUiArr = new Uint8Array(payload.length),
			    mx = tempUiArr.length;
			for (i; i < mx; ++i) {
				tempUiArr[i] = payload.charCodeAt(i);
			}payload = new myBlob([tempUiArr], { type: mimeType });
		}
	}
	blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

	function dataUrlToBlob(strUrl) {
		var parts = strUrl.split(/[:;,]/),
		    type = parts[1],
		    decoder = parts[2] == "base64" ? atob : decodeURIComponent,
		    binData = decoder(parts.pop()),
		    mx = binData.length,
		    i = 0,
		    uiArr = new Uint8Array(mx);

		for (i; i < mx; ++i) {
			uiArr[i] = binData.charCodeAt(i);
		}return new myBlob([uiArr], { type: type });
	}

	return _fileSaver2.default.saveAs(blob, fileName);
} /* end download() */